import "../../index67.css";
import { jsxs as E, Fragment as N, jsx as o } from "react/jsx-runtime";
import { useState as p, useRef as u, useEffect as P } from "react";
import { i as a } from "../../type-BFTbooL7.js";
import { _ as C } from "../../cs-piwRuCFZ.js";
import R from "../Container/index.js";
import w from "../Popup/index.js";
const D = "_tooltip-dummy_rbf3f_1", L = "_tooltip-content_rbf3f_7", b = "_pointer_rbf3f_14", n = {
  tooltipDummy: D,
  tooltipContent: L,
  pointer: b
};
function H(f) {
  const {
    className: c,
    title: l,
    description: d,
    preferredWidth: v
  } = f, [h, _] = p(!1), [y, r] = p(!1), s = u(), e = u(null);
  return P(
    () => {
      const i = () => {
        r(!0);
      }, m = () => {
        r(!1);
      };
      if (a(e.current))
        return;
      const {
        current: {
          parentNode: t
        }
      } = e;
      if (!a(t))
        return s.current = t, t.addEventListener("mouseover", i), t.addEventListener("mouseout", m), _(!0), () => {
          t.removeEventListener("mouseover", i), t.removeEventListener("mouseout", m);
        };
    },
    []
  ), /* @__PURE__ */ E(N, { children: [
    !h && /* @__PURE__ */ o(
      "div",
      {
        className: n.tooltipDummy,
        ref: e
      }
    ),
    y && /* @__PURE__ */ o(
      w,
      {
        className: C(n.tooltipContent, c),
        parentRef: s,
        pointerClassName: n.pointer,
        preferredWidth: v,
        children: /* @__PURE__ */ o(
          R,
          {
            heading: l,
            withInternalPadding: !0,
            contentViewType: "vertical",
            children: d
          }
        )
      }
    )
  ] });
}
export {
  H as default
};
